<template>
    <input
        class="input"
        type="text"
        :value="value"
        :placeholder="placeHolder"
        v-on:input="onChange"
    />
</template>

<script>

export default {
  props: ['value', 'placeHolder', 'onChange'],
  name: 'Input'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input {
    width: 220px;
    height: 40px;
    background-color: #fff;
    margin-bottom: 8px;
    border-radius: 4px;
    outline-style: none ;
    outline-width: 0px ;
    color: #000;
    text-indent: 12px;
    border: 1px solid #009688;
    -webkit-appearance: none;
}
</style>



// WEBPACK FOOTER //
// src/components/comm/Input.vue